if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
        this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this);
        this.updateButtonIcon = this.updateButtonIcon.bind(this);
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        this.controlButton = this.querySelector(
          ".shoppable-video__control-button",
        );

        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
          this.setupPlayPauseButton(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
          this.setupPlayPauseButton(this.video_background_section);
        }
      }

      setupPlayPauseButton(container) {
        if (!this.controlButton) return;

        this.videos = container.querySelectorAll("video");
        if (!this.videos.length) return;

        this.video_element = this.videos[0];
        this.controlButton.addEventListener("click", this.handlePlayPauseClick);
        this.videos.forEach((video) => {
          video.addEventListener("play", this.updateButtonIcon);
          video.addEventListener("pause", this.updateButtonIcon);
        });
      }

      handlePlayPauseClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.videos || !this.videos.length) return;

        const isAnyPlaying = Array.from(this.videos).some(
          (v) => !v.paused && !v.ended,
        );
        this.videos.forEach((video) => {
          if (isAnyPlaying) {
            video.pause();
          } else {
            video.play();
          }
        });
      }

      updateButtonIcon() {
        if (!this.controlButton || !this.videos) return;

        const isPlaying = Array.from(this.videos).some((v) => !v.paused);
        this.controlButton.classList.toggle(
          "shoppable-video__control-button--play",
          isPlaying,
        );
        this.controlButton.classList.toggle(
          "shoppable-video__control-button--pause",
          !isPlaying,
        );
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        const video_element = video_background_section.querySelector("video");
        if (video_element) {
          hero_overlay.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          hero_overlay.addEventListener("click", () =>
            this.playVideo(video_element),
          );
        }
      }

      checkAndPlayVideoSection(video) {
        const videos = video.querySelectorAll("video");
        if (videos.length) {
          const handler = (e) => {
            if (e.target.closest(".shoppable-video__control-button")) return;
            videos.forEach((v) => this.playVideo(v));
          };
          video.addEventListener("click", handler);
        }
      }

      playVideo(video_element) {
        if (video_element.paused) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this.controlButton) {
          this.controlButton.removeEventListener(
            "click",
            this.handlePlayPauseClick,
          );
        }
        if (this.videos) {
          this.videos.forEach((video) => {
            video.removeEventListener("play", this.updateButtonIcon);
            video.removeEventListener("pause", this.updateButtonIcon);
          });
        }
        if (this.video_section) {
          this.video_section.removeEventListener("click", this.playVideo);
        }
        if (this.video_background_section) {
          const hero_overlay =
            this.video_background_section.querySelector(".hero__overlay");
          const video_element =
            this.video_background_section.querySelector("video");
          if (video_element) {
            hero_overlay.removeEventListener("touchstart", () =>
              this.playVideo(video_element),
            );
            hero_overlay.removeEventListener("click", () =>
              this.playVideo(video_element),
            );
          }
        }
      }
    },
  );
}
